import { Grid, Paper, Text, Group, Stack, Flex, Tooltip } from "@mantine/core";
import { IconUsers, IconTrendingUp, IconClock, IconAlertTriangle, IconList } from "@tabler/icons-react";

const ICON_BG = {
    blue: "var(--mantine-color-blue-0)",
    green: "var(--mantine-color-green-0)",
    violet: "var(--mantine-color-violet-0)",
    red: "var(--mantine-color-red-0)",
    gray: "var(--mantine-color-gray-1)",
};

const KPICard = ({ icon: Icon, label, value, subtext, color, onClick }) => (
    <Paper
        shadow="xs"
        radius="md"
        p="md"
        withBorder
        style={{
            cursor: onClick ? "pointer" : "default",
            transition: "box-shadow 0.15s ease, border-color 0.15s ease",
        }}
        onMouseEnter={onClick ? (e) => {
            e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,0.1)";
            e.currentTarget.style.borderColor = `var(--mantine-color-${color}-4)`;
        } : undefined}
        onMouseLeave={onClick ? (e) => {
            e.currentTarget.style.boxShadow = "";
            e.currentTarget.style.borderColor = "";
        } : undefined}
        onClick={onClick}
    >
        <Flex gap="md" align="flex-start">
            {/* Caja de icono con fondo suave */}
            <Flex
                align="center"
                justify="center"
                style={{
                    width: 44,
                    height: 44,
                    borderRadius: 10,
                    backgroundColor: ICON_BG[color] || ICON_BG.gray,
                    flexShrink: 0,
                }}
            >
                <Icon size={22} color={`var(--mantine-color-${color}-6)`} />
            </Flex>

            {/* Contenido */}
            <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
                <Group gap={4} justify="space-between" wrap="nowrap">
                    <Text size="xs" c="dimmed" tt="uppercase" fw={600} lts={0.5}>
                        {label}
                    </Text>
                    {onClick && (
                        <Tooltip label="Ver listado completo" withArrow>
                            <IconList size={13} color="var(--mantine-color-dimmed)" />
                        </Tooltip>
                    )}
                </Group>
                <Text
                    fw={800}
                    lh={1.1}
                    style={{ fontSize: "1.75rem" }}
                    c={color === "red" && value > 0 ? "red.6" : undefined}
                >
                    {value}
                </Text>
                {subtext && (
                    <Text size="xs" c="dimmed" mt={2}>
                        {subtext}
                    </Text>
                )}
            </Stack>
        </Flex>
    </Paper>
);

/**
 * 4 tarjetas KPI principales del funnel.
 * La de "Total leads" es clickeable → abre listado de leads.
 */
export default function FunnelKPICards({ kpis, onViewLeads }) {
    if (!kpis) return null;

    const cards = [
        {
            icon: IconUsers,
            label: "Total leads",
            value: kpis.totalLeads ?? 0,
            subtext: `${kpis.convertedCount ?? 0} convertidos · ${kpis.lostCount ?? 0} perdidos`,
            color: "blue",
            onClick: onViewLeads,
        },
        {
            icon: IconTrendingUp,
            label: "Tasa de conversión",
            value: `${kpis.conversionRate ?? 0}%`,
            subtext: "Convertidos / Total leads",
            color: "green",
        },
        {
            icon: IconClock,
            label: "Tiempo prom. de cierre",
            value: kpis.avgCloseDays > 0 ? `${kpis.avgCloseDays}d` : "—",
            subtext: "Desde creación hasta conversión",
            color: "violet",
        },
        {
            icon: IconAlertTriangle,
            label: "Sin contactar",
            value: kpis.newWithoutContact ?? 0,
            subtext: "Leads nuevos sin interacciones",
            color: kpis.newWithoutContact > 0 ? "red" : "gray",
        },
    ];

    return (
        <Grid>
            {cards.map((card, idx) => (
                <Grid.Col key={idx} span={{ base: 6, md: 3 }}>
                    <KPICard {...card} />
                </Grid.Col>
            ))}
        </Grid>
    );
}
